import React from 'react';
import styled from 'styled-components';

const HashtagLink = styled.span`
    color: #1976d2;
    cursor: pointer;
    font-weight: 500;
    transition: color 0.2s;

    &:hover {
        color: #0d47a1;
        text-decoration: underline;
    }
`;

const HashtagText = ({ text, onHashtagClick }) => {
    if (!text) return null;

    // Regular expression to match hashtags (# followed by alphanumeric characters and underscores)
    const hashtagRegex = /#[\w]+/g;

    // Split the text by hashtags while preserving the hashtags
    const parts = [];
    let lastIndex = 0;
    let match;

    while ((match = hashtagRegex.exec(text)) !== null) {
        // Add text before the hashtag
        if (match.index > lastIndex) {
            parts.push({
                type: 'text',
                content: text.substring(lastIndex, match.index)
            });
        }

        // Add the hashtag
        parts.push({
            type: 'hashtag',
            content: match[0],
            tag: match[0].substring(1) // Remove the # symbol
        });

        lastIndex = match.index + match[0].length;
    }

    // Add any remaining text after the last hashtag
    if (lastIndex < text.length) {
        parts.push({
            type: 'text',
            content: text.substring(lastIndex)
        });
    }

    // If no hashtags were found, return the original text
    if (parts.length === 0) {
        return <span>{text}</span>;
    }

    return (
        <span>
            {parts.map((part, index) => {
                if (part.type === 'hashtag') {
                    return (
                        <HashtagLink
                            key={index}
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                if (onHashtagClick) {
                                    onHashtagClick(part.tag);
                                }
                            }}
                        >
                            {part.content}
                        </HashtagLink>
                    );
                }
                return <span key={index}>{part.content}</span>;
            })}
        </span>
    );
};

export default HashtagText;